import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import { computed } from 'vue';
import { ToggleGroupItem, ToggleGroupRoot } from 'radix-vue';

// Declared inline and without withDefaults: vue-tsc cannot see a generic component's props through an interface that mentions T, or through withDefaults.

export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleGroup',
  props: {
    modelValue: {},
    options: {},
    disabled: { type: Boolean },
    size: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const size = computed(() => props.size ?? 'default');

const emit = __emit;

const selectedIndex = computed(() => {
    const index = props.options.findIndex((option) => option.value === props.modelValue);

    return index === -1 ? 0 : index;
});

function onUpdate(value: string | string[] | undefined) {
    // Radix emits an empty value when the active item is clicked again; a selection is always required here, so ignore it.
    const selected = props.options.find((option) => String(option.value) === value);

    if (selected && selected.value !== props.modelValue) {
        emit('update:modelValue', selected.value);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-gray-200 rounded-md inline-block", {
            'opacity-50 cursor-not-allowed': props.disabled,
            'p-0.5': size.value === 'sm',
            'p-1': size.value === 'default',
        }])
  }, [
    _createVNode(_unref(ToggleGroupRoot), {
      type: "single",
      "model-value": String(props.modelValue),
      disabled: props.disabled,
      class: "grid relative overflow-hidden",
      style: _normalizeStyle({ gridTemplateColumns: `repeat(${props.options.length}, minmax(0, 1fr))` }),
      "onUpdate:modelValue": onUpdate
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "absolute top-0 left-0 h-full rounded-md bg-primary-800 transition-transform duration-300",
          style: _normalizeStyle({ width: `${100 / props.options.length}%`, transform: `translateX(${selectedIndex.value * 100}%)` }),
          "aria-hidden": "true"
        }, null, 4),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
          return (_openBlock(), _createBlock(_unref(ToggleGroupItem), {
            key: String(option.value),
            value: String(option.value),
            class: _normalizeClass(["relative h-full border-0 transition-colors duration-300 focus:outline-none font-medium whitespace-nowrap disabled:cursor-not-allowed", {
                    'text-white': option.value === props.modelValue,
                    'px-2 py-1 text-sm': size.value === 'sm',
                    'px-4 py-2': size.value === 'default',
                }])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(option.label), 1)
            ]),
            _: 2
          }, 1032, ["value", "class"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value", "disabled", "style"])
  ], 2))
}
}

})